import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import InsightDialog from "./InsightDialog";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function Insight({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                "Insight - "
            }
            {
                (callTableViewModel.filters.insight.question != '') ?
                    callTableViewModel.filters.insight.question + ' - ' + callTableViewModel.filters.insight.answer
                    : ' Is Any'
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <InsightDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}